import { EventQueryHandler, FlowUpdatedEventQueryHandler, IndexUpdatedEventQueryHandler, SubscriptionUnitsUpdatedEventQueryHandler, TransferEventQueryHandler, } from '@superfluid-finance/sdk-core';
import { getSubgraphClient } from '../../../../sdkReduxConfig';
import { createGeneralTags } from '../../cacheTags/CacheTagTypes';
import { CacheTime } from '../../cacheTime';
import { provideSpecificCacheTagsFromRelevantAddresses } from '../provideSpecificCacheTagsFromRelevantAddresses';
export const createEventQueryEndpoints = (builder) => {
    // NOTE: Ignoring prettier because longer lines are more readable here.
    // prettier-ignore
    return {
        event: get(builder, new EventQueryHandler()),
        events: list(builder, new EventQueryHandler()),
        flowUpdatedEvent: get(builder, new FlowUpdatedEventQueryHandler()),
        flowUpdatedEvents: list(builder, new FlowUpdatedEventQueryHandler()),
        indexUpdatedEvent: get(builder, new IndexUpdatedEventQueryHandler()),
        indexUpdatedEvents: list(builder, new IndexUpdatedEventQueryHandler()),
        subscriptionUnitsUpdatedEvent: get(builder, new SubscriptionUnitsUpdatedEventQueryHandler()),
        subscriptionUnitsUpdatedEvents: list(builder, new SubscriptionUnitsUpdatedEventQueryHandler()),
        transferEvent: get(builder, new TransferEventQueryHandler()),
        transferEvents: list(builder, new TransferEventQueryHandler())
    };
};
/**
 * Creates "get" endpoint.
 */
function get(builder, queryHandler) {
    return builder.query({
        queryFn: async (arg) => {
            const subgraphClient = await getSubgraphClient(arg.chainId);
            return {
                data: await queryHandler.get(subgraphClient, arg),
            };
        },
        keepUnusedDataFor: CacheTime.Forever, // Events don't change (unless re-org but that's handled by invalidating whole cache anyway).
    });
}
/**
 * Creates "list" endpoint.
 */
function list(builder, queryHandler) {
    return builder.query({
        queryFn: async (arg) => {
            const subgraphClient = await getSubgraphClient(arg.chainId);
            return {
                data: await queryHandler.list(subgraphClient, arg),
            };
        },
        providesTags: (_result, _error, arg) => [
            ...createGeneralTags({ chainId: arg.chainId }),
            ...provideSpecificCacheTagsFromRelevantAddresses(arg.chainId, queryHandler.getRelevantAddressesFromFilter(arg.filter)),
        ],
    });
}
//# sourceMappingURL=eventEndpoints.js.map